import { ProviderBuilder, EGenMode } from '@educraft/base';
import { Blocek_Procenta } from './generators/Blocek_Procenta';
import {
  KalendarRok__Base,
  KalendarRok__TentoRok,
  KalendarRok__DalsiRok,
} from './generators/KalendarRok__Base';
import {
  ColorMultiplesBase,
  Vybarvi_MalaNasobilka__1,
  Vybarvi_MalaNasobilka__2,
  Vybarvi_MalaNasobilka__3,
  Vybarvi_MalaNasobilka__4,
  Vybarvi_MalaNasobilka__5,
  Vybarvi_MalaNasobilka__6,
  Vybarvi_MalaNasobilka__7,
  Vybarvi_MalaNasobilka__8,
  Vybarvi_MalaNasobilka__9,
  Vybarvi_MalaNasobilka__10,
} from './generators/ColorMultiplesBase';
import {
  GeoBoard__8__Bludiste1,
  GeoBoard__8__Bludiste2,
  GeoBoard__920__Bludiste1,
  GeoBoard__920__Bludiste2,
} from './generators/GeoBoard_Bludiste';
import {
  GeoBoard__8__Rotace90CW,
  GeoBoard__8__Rotace90CCW,
  GeoBoard__8__Soumernost_Osa1V,
  GeoBoard__8__Soumernost_Osa1H,
  GeoBoard__8__Soumernost_Osy2,
  GeoBoard__8__Soumernost_Stredova,
  GeoBoard__8__PosunH,
  GeoBoard__8__PosunV,
  GeoBoard__8__Zvetseni,
  GeoBoard__8__Obsah,
  GeoBoard__8__Rozdeleni,
  GeoBoard__920__Rotace90CW,
  GeoBoard__920__Rotace90CCW,
  GeoBoard__920__Soumernost_Osa1V,
  GeoBoard__920__Soumernost_Osa1H,
  GeoBoard__920__Soumernost_Osy2,
  GeoBoard__920__Soumernost_Stredova,
  GeoBoard__920__PosunH,
  GeoBoard__920__PosunV,
  GeoBoard__920__Zvetseni,
  GeoBoard__920__Obsah,
  GeoBoard__920__Rozdeleni,
} from './generators/GeoBoard_Transformations';
import {
  Piccolo_Tabulka_100,
  Piccolo_Tabulka__Nasobeni1,
  Piccolo_Tabulka__Nasobeni2,
  Piccolo_Tabulka__Nasobeni3,
  Piccolo_Tabulka__Nasobeni4,
  Piccolo_Tabulka__Nasobeni5,
  Piccolo_Tabulka__Nasobeni6,
  Piccolo_Tabulka__Nasobeni7,
  Piccolo_Tabulka__Nasobeni8,
  Piccolo_Tabulka__Nasobeni9,
  Piccolo_Tabulka__Nasobeni10,
  Piccolo_Tabulka__Scitani1,
  Piccolo_Tabulka__Scitani2,
  Piccolo_Tabulka__Scitani3,
  Piccolo_Tabulka__Scitani4,
  Piccolo_Tabulka__Scitani5,
  Piccolo_Tabulka__Scitani6,
  Piccolo_Tabulka__Scitani7,
  Piccolo_Tabulka__Scitani8,
  Piccolo_Tabulka__Scitani9,
  Piccolo_Tabulka__Scitani10,
} from './generators/Piccolo_Tabulka';
import {
  Nasobilka_Plakaty__Barevne,
  Nasobilka_Plakaty__Cernobile,
} from './generators/Nasobilka_Plakaty';
import {
  Piccolo_Mapa__CR__Kraje,
  Piccolo_Mapa__CR__KrajskaMesta,
  Piccolo_Mapa__Evropa__HlavniMesta,
  Piccolo_Mapa__OlomouckyKraj__Zajimavosti,
  Piccolo_Mapa__Svet__Staty,
  Primo_Mapa__CR__Kraje,
  Primo_Mapa__CR__KrajskaMesta,
  Primo_Mapa__Evropa__HlavniMesta,
  Primo_Mapa__OlomouckyKraj__Zajimavosti,
  Primo_Mapa__Svet__Staty,
  Maximo_Mapa__CR__Kraje,
  Maximo_Mapa__CR__KrajskaMesta,
  Maximo_Mapa__Evropa__HlavniMesta,
  Maximo_Mapa__Svet__Staty,
} from './generators/LogicoMapGenerators';
import {
  Piccolo_Fun__Sin,
  Piccolo_Fun__Cos,
  Piccolo_Fun__Linear,
  Piccolo_Fun__Abs,
  Piccolo_Fun__1X,
  Piccolo_Fun__Sqrt,
  Piccolo_Fun__X2,
  Piccolo_Fun__X3,
  Piccolo_Fun__Log,
  Piccolo_Fun__Exp,
  Primo_Fun__Sin,
  Primo_Fun__Cos,
  Primo_Fun__Linear,
  Primo_Fun__Abs,
  Primo_Fun__1X,
  Primo_Fun__Sqrt,
  Primo_Fun__X2,
  Primo_Fun__X3,
  Primo_Fun__Log,
  Primo_Fun__Exp,
} from './generators/Piccolo_Fun';
import {
  LCD_Tabulka_Mapa__CR__Kraje,
  LCD_Tabulka_Mapa__CR__KrajskaMesta,
  LCD_Tabulka_Mapa__Evropa__HlavniMesta,
  LCD_Tabulka_Mapa__Svet__Staty,
} from './generators/LcdTableMapBase';
import {
  Sudoku__4x4__Easy,
  Sudoku__4x4__Medium,
  Sudoku__4x4__Hard,
  Sudoku__4x4__Expert,
  Sudoku__9x9__Easy,
  Sudoku__9x9__Medium,
  Sudoku__9x9__Hard,
  Sudoku__9x9__Expert,
  Sudoku__16x16__Easy,
  Sudoku__16x16__Medium,
  Sudoku__16x16__Hard,
} from './generators/Sudoku';

export function registerLayoutBase(builder: ProviderBuilder) {
  // Original generator
  builder.add(EGenMode.LayoutBase, Blocek_Procenta, 'Base.Blocek_Procenta');

  // Calendar
  builder.add(EGenMode.LayoutBase, KalendarRok__TentoRok, 'Base.KalendarRok__TentoRok');
  builder.add(EGenMode.LayoutBase, KalendarRok__DalsiRok, 'Base.KalendarRok__DalsiRok');

  // Color multiples (Vybarvi MalaNasobilka)
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__1, 'Base.Vybarvi_MalaNasobilka__1');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__2, 'Base.Vybarvi_MalaNasobilka__2');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__3, 'Base.Vybarvi_MalaNasobilka__3');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__4, 'Base.Vybarvi_MalaNasobilka__4');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__5, 'Base.Vybarvi_MalaNasobilka__5');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__6, 'Base.Vybarvi_MalaNasobilka__6');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__7, 'Base.Vybarvi_MalaNasobilka__7');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__8, 'Base.Vybarvi_MalaNasobilka__8');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__9, 'Base.Vybarvi_MalaNasobilka__9');
  builder.add(EGenMode.LayoutBase, Vybarvi_MalaNasobilka__10, 'Base.Vybarvi_MalaNasobilka__10');

  builder.add(EGenMode.LayoutBase, GeoBoard__8__Bludiste1, 'Base.GeoBoard__8__Bludiste1');
  builder.add(EGenMode.LayoutBase, GeoBoard__8__Bludiste2, 'Base.GeoBoard__8__Bludiste2');

  builder.add(EGenMode.LayoutBase, GeoBoard__920__Bludiste1, 'Base.GeoBoard__920__Bludiste1');
  builder.add(EGenMode.LayoutBase, GeoBoard__920__Bludiste2, 'Base.GeoBoard__920__Bludiste2');

  builder.add(EGenMode.LayoutBase, GeoBoard__8__Rotace90CW, 'Base.GeoBoard__8__Rotace90CW');
  builder.add(EGenMode.LayoutBase, GeoBoard__8__Rotace90CCW, 'Base.GeoBoard__8__Rotace90CCW');
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__8__Soumernost_Osa1V,
    'Base.GeoBoard__8__Soumernost_Osa1V'
  );
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__8__Soumernost_Osa1H,
    'Base.GeoBoard__8__Soumernost_Osa1H'
  );
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__8__Soumernost_Osy2,
    'Base.GeoBoard__8__Soumernost_Osy2'
  );
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__8__Soumernost_Stredova,
    'Base.GeoBoard__8__Soumernost_Stredova'
  );
  builder.add(EGenMode.LayoutBase, GeoBoard__8__PosunH, 'Base.GeoBoard__8__PosunH');
  builder.add(EGenMode.LayoutBase, GeoBoard__8__PosunV, 'Base.GeoBoard__8__PosunV');
  builder.add(EGenMode.LayoutBase, GeoBoard__8__Zvetseni, 'Base.GeoBoard__8__Zvetseni');
  builder.add(EGenMode.LayoutBase, GeoBoard__8__Obsah, 'Base.GeoBoard__8__Obsah');
  builder.add(EGenMode.LayoutBase, GeoBoard__8__Rozdeleni, 'Base.GeoBoard__8__Rozdeleni');

  builder.add(EGenMode.LayoutBase, GeoBoard__920__Rotace90CW, 'Base.GeoBoard__920__Rotace90CW');
  builder.add(EGenMode.LayoutBase, GeoBoard__920__Rotace90CCW, 'Base.GeoBoard__920__Rotace90CCW');
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__920__Soumernost_Osa1V,
    'Base.GeoBoard__920__Soumernost_Osa1V'
  );
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__920__Soumernost_Osa1H,
    'Base.GeoBoard__920__Soumernost_Osa1H'
  );
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__920__Soumernost_Osy2,
    'Base.GeoBoard__920__Soumernost_Osy2'
  );
  builder.add(
    EGenMode.LayoutBase,
    GeoBoard__920__Soumernost_Stredova,
    'Base.GeoBoard__920__Soumernost_Stredova'
  );
  builder.add(EGenMode.LayoutBase, GeoBoard__920__PosunH, 'Base.GeoBoard__920__PosunH');
  builder.add(EGenMode.LayoutBase, GeoBoard__920__PosunV, 'Base.GeoBoard__920__PosunV');
  builder.add(EGenMode.LayoutBase, GeoBoard__920__Zvetseni, 'Base.GeoBoard__920__Zvetseni');
  builder.add(EGenMode.LayoutBase, GeoBoard__920__Obsah, 'Base.GeoBoard__920__Obsah');
  builder.add(EGenMode.LayoutBase, GeoBoard__920__Rozdeleni, 'Base.GeoBoard__920__Rozdeleni');

  // Piccolo Tabulka 100
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka_100, 'Base.Piccolo_Tabulka_100');

  // Piccolo Tabulka Nasobeni (Multiplication)
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni1, 'Base.Piccolo_Tabulka__Nasobeni1');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni2, 'Base.Piccolo_Tabulka__Nasobeni2');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni3, 'Base.Piccolo_Tabulka__Nasobeni3');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni4, 'Base.Piccolo_Tabulka__Nasobeni4');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni5, 'Base.Piccolo_Tabulka__Nasobeni5');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni6, 'Base.Piccolo_Tabulka__Nasobeni6');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni7, 'Base.Piccolo_Tabulka__Nasobeni7');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni8, 'Base.Piccolo_Tabulka__Nasobeni8');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni9, 'Base.Piccolo_Tabulka__Nasobeni9');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Nasobeni10, 'Base.Piccolo_Tabulka__Nasobeni10');

  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani1, 'Base.Piccolo_Tabulka__Scitani1');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani2, 'Base.Piccolo_Tabulka__Scitani2');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani3, 'Base.Piccolo_Tabulka__Scitani3');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani4, 'Base.Piccolo_Tabulka__Scitani4');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani5, 'Base.Piccolo_Tabulka__Scitani5');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani6, 'Base.Piccolo_Tabulka__Scitani6');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani7, 'Base.Piccolo_Tabulka__Scitani7');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani8, 'Base.Piccolo_Tabulka__Scitani8');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani9, 'Base.Piccolo_Tabulka__Scitani9');
  builder.add(EGenMode.LayoutBase, Piccolo_Tabulka__Scitani10, 'Base.Piccolo_Tabulka__Scitani10');

  // Nasobilka Plakaty (Multiplication Posters)
  builder.add(EGenMode.LayoutBase, Nasobilka_Plakaty__Barevne, 'Base.Nasobilka_Plakaty__Barevne');
  builder.add(
    EGenMode.LayoutBase,
    Nasobilka_Plakaty__Cernobile,
    'Base.Nasobilka_Plakaty__Cernobile'
  );

  // Piccolo Map Generators (require map data to be registered via MapDataRegistry)
  builder.add(EGenMode.LayoutBase, Piccolo_Mapa__CR__Kraje, 'Base.Piccolo_Mapa__CR__Kraje');
  builder.add(
    EGenMode.LayoutBase,
    Piccolo_Mapa__CR__KrajskaMesta,
    'Base.Piccolo_Mapa__CR__KrajskaMesta'
  );
  builder.add(
    EGenMode.LayoutBase,
    Piccolo_Mapa__Evropa__HlavniMesta,
    'Base.Piccolo_Mapa__Evropa__HlavniMesta'
  );
  builder.add(
    EGenMode.LayoutBase,
    Piccolo_Mapa__OlomouckyKraj__Zajimavosti,
    'Base.Piccolo_Mapa__OlomouckyKraj__Zajimavosti'
  );
  builder.add(EGenMode.LayoutBase, Piccolo_Mapa__Svet__Staty, 'Base.Piccolo_Mapa__Svet__Staty');

  builder.add(EGenMode.LayoutBase, Primo_Mapa__CR__Kraje, 'Base.Primo_Mapa__CR__Kraje');
  builder.add(
    EGenMode.LayoutBase,
    Primo_Mapa__CR__KrajskaMesta,
    'Base.Primo_Mapa__CR__KrajskaMesta'
  );
  builder.add(
    EGenMode.LayoutBase,
    Primo_Mapa__Evropa__HlavniMesta,
    'Base.Primo_Mapa__Evropa__HlavniMesta'
  );
  builder.add(
    EGenMode.LayoutBase,
    Primo_Mapa__OlomouckyKraj__Zajimavosti,
    'Base.Primo_Mapa__OlomouckyKraj__Zajimavosti'
  );
  builder.add(EGenMode.LayoutBase, Primo_Mapa__Svet__Staty, 'Base.Primo_Mapa__Svet__Staty');

  builder.add(EGenMode.LayoutBase, Maximo_Mapa__CR__Kraje, 'Base.Maximo_Mapa__CR__Kraje');
  builder.add(
    EGenMode.LayoutBase,
    Maximo_Mapa__CR__KrajskaMesta,
    'Base.Maximo_Mapa__CR__KrajskaMesta'
  );
  builder.add(
    EGenMode.LayoutBase,
    Maximo_Mapa__Evropa__HlavniMesta,
    'Base.Maximo_Mapa__Evropa__HlavniMesta'
  );
  builder.add(EGenMode.LayoutBase, Maximo_Mapa__Svet__Staty, 'Base.Maximo_Mapa__Svet__Staty');

  // Piccolo Fun (function graphs)
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__Sin, 'Base.Piccolo_Fun__Sin');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__Cos, 'Base.Piccolo_Fun__Cos');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__Linear, 'Base.Piccolo_Fun__Linear');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__Abs, 'Base.Piccolo_Fun__Abs');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__1X, 'Base.Piccolo_Fun__1X');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__Sqrt, 'Base.Piccolo_Fun__Sqrt');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__X2, 'Base.Piccolo_Fun__X2');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__X3, 'Base.Piccolo_Fun__X3');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__Log, 'Base.Piccolo_Fun__Log');
  builder.add(EGenMode.LayoutBase, Piccolo_Fun__Exp, 'Base.Piccolo_Fun__Exp');

  builder.add(EGenMode.LayoutBase, Primo_Fun__Sin, 'Base.Primo_Fun__Sin');
  builder.add(EGenMode.LayoutBase, Primo_Fun__Cos, 'Base.Primo_Fun__Cos');
  builder.add(EGenMode.LayoutBase, Primo_Fun__Linear, 'Base.Primo_Fun__Linear');
  builder.add(EGenMode.LayoutBase, Primo_Fun__Abs, 'Base.Primo_Fun__Abs');
  builder.add(EGenMode.LayoutBase, Primo_Fun__1X, 'Base.Primo_Fun__1X');
  builder.add(EGenMode.LayoutBase, Primo_Fun__Sqrt, 'Base.Primo_Fun__Sqrt');
  builder.add(EGenMode.LayoutBase, Primo_Fun__X2, 'Base.Primo_Fun__X2');
  builder.add(EGenMode.LayoutBase, Primo_Fun__X3, 'Base.Primo_Fun__X3');
  builder.add(EGenMode.LayoutBase, Primo_Fun__Log, 'Base.Primo_Fun__Log');
  builder.add(EGenMode.LayoutBase, Primo_Fun__Exp, 'Base.Primo_Fun__Exp');

  builder.add(EGenMode.LayoutBase, LCD_Tabulka_Mapa__CR__Kraje, 'Base.LCD_Tabulka_Mapa__CR__Kraje');
  builder.add(
    EGenMode.LayoutBase,
    LCD_Tabulka_Mapa__CR__KrajskaMesta,
    'Base.LCD_Tabulka_Mapa__CR__KrajskaMesta'
  );
  builder.add(
    EGenMode.LayoutBase,
    LCD_Tabulka_Mapa__Evropa__HlavniMesta,
    'Base.LCD_Tabulka_Mapa__Evropa__HlavniMesta'
  );
  builder.add(
    EGenMode.LayoutBase,
    LCD_Tabulka_Mapa__Svet__Staty,
    'Base.LCD_Tabulka_Mapa__Svet__Staty'
  );

  // Sudoku
  builder.add(EGenMode.LayoutBase, Sudoku__4x4__Easy, 'Base.Sudoku__4x4__Easy');
  builder.add(EGenMode.LayoutBase, Sudoku__4x4__Medium, 'Base.Sudoku__4x4__Medium');
  builder.add(EGenMode.LayoutBase, Sudoku__4x4__Hard, 'Base.Sudoku__4x4__Hard');
  builder.add(EGenMode.LayoutBase, Sudoku__4x4__Expert, 'Base.Sudoku__4x4__Expert');
  builder.add(EGenMode.LayoutBase, Sudoku__9x9__Easy, 'Base.Sudoku__9x9__Easy');
  builder.add(EGenMode.LayoutBase, Sudoku__9x9__Medium, 'Base.Sudoku__9x9__Medium');
  builder.add(EGenMode.LayoutBase, Sudoku__9x9__Hard, 'Base.Sudoku__9x9__Hard');
  builder.add(EGenMode.LayoutBase, Sudoku__9x9__Expert, 'Base.Sudoku__9x9__Expert');
  builder.add(EGenMode.LayoutBase, Sudoku__16x16__Easy, 'Base.Sudoku__16x16__Easy');
  builder.add(EGenMode.LayoutBase, Sudoku__16x16__Medium, 'Base.Sudoku__16x16__Medium');
  builder.add(EGenMode.LayoutBase, Sudoku__16x16__Hard, 'Base.Sudoku__16x16__Hard');
}
